import React from "react";
import { Text } from "react-internationalization";
const PlanNotFound = () => {
  return (
    <h3 class="tab-heading mt-5 text-center"><Text id="sharp.ndf"/></h3>
  );
};
export default PlanNotFound;
